import React from 'react';
export function PromiseSection() {
  return <section className="bg-promise-gradient py-10 px-5 text-center relative overflow-hidden" data-id="element-142">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[200px] opacity-[0.03] pointer-events-none" data-id="element-143">
        💎
      </div>
      <div className="max-w-[800px] mx-auto" data-id="element-144">
        <div className="bg-promise-box border-2 border-dorado rounded-2xl py-8 px-6 relative" data-id="element-145">
          <div className="absolute top-[-13px] left-1/2 -translate-x-1/2 bg-gradient-gold-rose text-negro py-1 px-5 rounded-full text-[11px] font-bold tracking-[2px] whitespace-nowrap" data-id="element-146">
            ★ PROMESA IRRESISTIBLE ★
          </div>
          <h2 className="font-playfair text-[clamp(20px,3vw,30px)] text-blanco leading-[1.35] mb-3" data-id="element-147">
            En menos de 30 días vas a tener chocolates con acabado de joyería,
            un feed de Instagram que{' '}
            <em className="text-teal not-italic" data-id="element-148">para el scroll</em> y tu primer
            pedido confirmado a precio premium —
            <em className="text-teal not-italic" data-id="element-149">
              {' '}
              o te devolvemos el 100%, sin preguntas.
            </em>
          </h2>
          <p className="text-[14px] text-oro-rosa-claro leading-[1.6] italic" data-id="element-150">
            Un sistema probado, diseñado para la realidad argentina: clima,
            insumos locales y la forma en que compran tus clientes.
          </p>
        </div>
      </div>
    </section>;
}